module.exports = __webpack_public_path__ + "img/diagram2.8d06a1bf.png";